export class DocumentKindVals {
    public static readonly Passport = 1;
    public static readonly OperationManual = 2;
    public static readonly ConformityCertificate = 3;
    public static readonly QualityCertificate = 4;
    public static readonly ConformityDeclaration = 5;
    public static readonly TestProtocol = 6;
    public static readonly QualityDocument = 7;
    public static readonly InformationLetters = 8;
    public static readonly Other = 9;

    public static readonly Items = [
        { Id: DocumentKindVals.Passport,              Title: 'Паспорт' },
        { Id: DocumentKindVals.OperationManual,        Title: 'Руководство по эксплуатации' },
        { Id: DocumentKindVals.ConformityCertificate,  Title: 'Сертификат соответствия' },
        { Id: DocumentKindVals.QualityCertificate,     Title: 'Сертификат качества' },
        { Id: DocumentKindVals.ConformityDeclaration,  Title: 'Декларация о соответствии' },
        { Id: DocumentKindVals.TestProtocol,           Title: 'Протокол испытаний' },
        { Id: DocumentKindVals.QualityDocument,        Title: 'Документ о качестве' },
        { Id: DocumentKindVals.InformationLetters,     Title: 'Информационные письма' },
        { Id: DocumentKindVals.Other,                  Title: 'Другой' },
    ];

    public static isDateRange(docKindId: number): boolean {
        return docKindId === DocumentKindVals.ConformityCertificate
            || docKindId === DocumentKindVals.QualityCertificate
            || docKindId === DocumentKindVals.ConformityDeclaration;
    }
}